import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { APIFactoryEndPoints } from "src/app/common/apifactory-end-points";
import { LocalStorageService } from "src/app/common/LocalStorageService";
import { GoogleCustomer } from "src/app/shared/models/googlecustomer";
import { UserService } from "src/app/shared/services/user.service";
import { getWindow } from "ssr-window";
enum PaymentState {
  VERIFYING = 'VERIFYING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PAYMENT_DONE_ORDER_PENDING = 'PAYMENT_DONE_ORDER_PENDING'
}

@Component({
  selector: "app-payment-status",
  templateUrl: "./payment-status.component.html",
  styleUrls: ["./payment-status.component.scss"],
})
export class PaymentStatusComponent implements OnInit {

  googleCustomer: GoogleCustomer;
  currentUrl: string;

  state: PaymentState = PaymentState.VERIFYING;
  PaymentState = PaymentState;

  attempt = 0;
  maxRetries = 6;

  retryDelayMs = 10000; // 10 sec
  totalTimeSeconds = (this.maxRetries * this.retryDelayMs) / 1000;

  remainingSeconds = this.totalTimeSeconds;
  progressPercent = 0;

  private timerInterval: any;

  private pollTimeout: any;
  private pollingSub!: Subscription;
  private destroyed = false;

  private cartSetUpSubscription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    private route: ActivatedRoute,
    private apiFactory: APIFactoryEndPoints,
    private navRoute: Router,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.route.queryParams.subscribe((data) => {
      if (data) {
        console.log("data", data);
        this.startVerification(data);
      }
    });
    this.currentUrl = getWindow().location.hostname;
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.stopAll();
  }

  startVerification(data: any) {
    if (!data['trans_id']) return;

    const transactionId = data['trans_id'];

    this.startTimer();

    const pollStatus = () => {

      if (this.destroyed) return; // ✅ prevent further calls

      this.attempt++;

      this.pollingSub = this.userService
        .getOrderDetailsByOrderNo(
          this.apiFactory.getExceptionWebOrderByOrderNo,
          transactionId
        )
        .subscribe({
          next: (resp: any) => {

            const webStatus = resp?.hasWebOrderResponse;
            const ccStatus = resp?.hasCCAvenueResponse;

            // ✅ SUCCESS
            if (webStatus === 'Success') {
              this.stopAll();
              this.state = PaymentState.SUCCESS;

              const ids = resp.productCodes?.split(',').map(Number) || [];
              this.removeCartProductsAndRedirect(ids);
              return;
            }

            // ❌ FAILURE
            if (ccStatus === 'Aborted' ||
              ccStatus === 'Failure' ||
              ccStatus === 'Timeout') {

              this.stopAll();
              this.state = PaymentState.FAILED;
              this.navRoute.navigate(['/payment-fail']);
              return;
            }

            // ⏳ RETRY
            if (this.attempt < this.maxRetries) {

              this.pollTimeout = setTimeout(() => {
                if (!this.destroyed) {
                  pollStatus();
                }
              }, this.retryDelayMs);

            } else {
              this.handleFinalState(ccStatus, webStatus);
            }
          },
          error: () => {
            if (this.attempt < this.maxRetries) {

              this.pollTimeout = setTimeout(() => {
                if (!this.destroyed) {
                  pollStatus();
                }
              }, this.retryDelayMs);

            } else {
              this.stopAll();
              this.state = PaymentState.FAILED;
              this.navRoute.navigate(['/payment-fail']);
            }
          }
        });
    };

    pollStatus();
  }

  // ✅ Stop everything safely
  private stopAll() {
    if (this.pollTimeout) {
      clearTimeout(this.pollTimeout);
    }

    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
    }

    this.stopTimer();
  }

  // ✅ Final State Decision After Max Retry
  private handleFinalState(ccStatus: string, webStatus: string) {
    this.stopTimer();
    if (ccStatus === 'Success' && webStatus === 'Failed') {
      this.state = PaymentState.PAYMENT_DONE_ORDER_PENDING;
      return;
    }
    this.state = PaymentState.FAILED;
    this.navRoute.navigate(['/payment-fail']);
  }

  startTimer() {
    this.remainingSeconds = this.totalTimeSeconds;
    this.progressPercent = 0;

    this.timerInterval = setInterval(() => {
      this.remainingSeconds--;

      this.progressPercent =
        ((this.totalTimeSeconds - this.remainingSeconds) /
          this.totalTimeSeconds) *
        100;

      if (this.remainingSeconds <= 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.timerInterval);
  }

  removeCartProductsAndRedirect(data: number[]) {
    if (data.length > 0) {
      this.cartSetUpSubscription = this.userService.emptyProductCart(this.apiFactory.emptyProductCart, this.googleCustomer.email, this.currentUrl)
        .subscribe((data: any) => {
          console.log(data.Res);
          // window.location.reload();
          this.navRoute.navigate(["/payment-success"], {
            state: { data: "reload" },
          });
        });
    }
  }

  removeCartProducts(data: Params) {
    if (data["status"] != null) {
      if (data["status"] == "Success") {
        if (data["ids"] == "all") {
          this.cartSetUpSubscription = this.userService.emptyProductCart(this.apiFactory.emptyProductCart, this.googleCustomer.email, this.currentUrl)
            .subscribe((data: any) => {
              console.log(data.Res);
              // window.location.reload();
              this.navRoute.navigate(["/payment-success"], {
                state: { data: "reload" },
              });
            });
        } else {
          this.cartSetUpSubscription = this.userService.removeAllProductCart(this.apiFactory.removeAllProductFromCart, this.googleCustomer.email, data["ids"], this.currentUrl)
            .subscribe((data: any) => {
              console.log(data);
              // window.location.reload();
              this.navRoute.navigate(["/payment-success"], {
                state: { data: "reload" },
              });
            });
        }
      }
    }
  }

  goToHome() {
    this.navRoute.navigate(["/payment-history"]);
  }
}
